// @ts-nocheck
import React, { useState } from 'react';
import MyInput from '../components/ui/MyInput';
import PrimaryButton from '../components/ui/PrimaryButton';
import CreateAction from '../components/operational/createAction';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import MobligoLogo from '../assets/img/mobligo_new.png';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordComponent = ({ setPage }) => {
  const [email, setEmail] = useState('');
  const [isMailSent, setIsMailSent] = useState(false);
  const [isError, setIsError] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLoginPress = async event => {
    if (event.key === 'Enter') {
      await handleLoginClickButton();
    }
  };

  const handleLoginClickButton = async () => {
    const response = await CreateAction({
      method: 'post',
      path: '/sso/forgotPassword',
      data: { email },
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response?.error) return setIsError(true);
    setIsMailSent(true);
    // setUserInformation(response);
    // window.location.href = '/changePassword';
  };

  return (
    <div className="authPage d-flex overflow-auto">
      <div className="login bg-[#ffffff] h-[100vh] overflow:hidden flex justify-center">
        <div className="relative flex flex-row flex-wrap items-center justify-center h-[100%]">
          <div className="z-[1000] w-[300px] sm:w-[500px] bg-[#FFFFFF] rounded-xl">
            <div className="flex flex-col justify-center  items-center gap-3 h-max">
              <a className="w-full flex items-center justify-center" href="/">
                <img className="w-[70%] xl:w-[43%] lg:w-[43%] mt-5" src={MobligoLogo} alt="" />
              </a>
              {isMailSent ? (
                <div>
                  <h2 className="text-[#8A92A6] font-medium">
                    Şifreniz Mailinize Gönderilmiştir. Adımları izleyerek şifrenizi sıfırlayabilirsiniz.
                  </h2>
                  <div className="flex flex-row text-center justify-center gap-2 items-center mt-4">
                    <span
                      className="text-md font-medium dark:text-slate-200 text-[#6f66f6] cursor-pointer"
                      onClick={e => {
                        navigate('/login');
                      }}
                    >
                      Girişe Dön
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  <p className="text-[#8A92A6] font-medium text-lg">Şifrenizi mi unuttunuz?</p>
                  <div className="w-[300px] sm:w-[500px] mt-7 gap-3 flex flex-col">
                    <MyInput
                      isError={isError}
                      type="text"
                      color="black"
                      onKeyDown={handleLoginPress}
                      classes="bg-transparent z-20 h-14"
                      onChange={(e: any) => {
                        setEmail(e);
                        setIsError(false);
                      }}
                      placeholder="E-posta"
                      value={email}
                    ></MyInput>
                    {isError && (
                      <div className="flex  items-start">
                        <p className="text-[#C5000B] text-sm px-1">
                          Lütfen hesap adınızı ve parolanızı kontrol edip tekrar deneyin.
                        </p>
                      </div>
                    )}

                    <PrimaryButton
                      classes={'py-4 my-2 rounded h-14 bg-[#6F66F6] transition duration-150'}
                      loading={false}
                      onClick={handleLoginClickButton}
                      value="Şifremi Yenile"
                    ></PrimaryButton>
                  </div>

                  <div className="flex flex-row text-center justify-center gap-2 items-center mt-4">
                    <p className="text-[#8A92A6]">Hesabınız yok mu? </p>
                    <span
                      className="text-md font-medium dark:text-slate-200 text-[#6f66f6] cursor-pointer"
                      onClick={e => {
                        navigate('/register');
                      }}
                    >
                      Kayıt Ol
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordComponent;
